import { useAppSelector } from '@/redux/hooks';

export function useIsStorefrontChannel() {
  return useAppSelector((state) => {
    const ch = (state as any)?.layout?.channel || (state as any)?.auth?.channel;
    if (ch) return String(ch).toLowerCase() === 'storefront';
    if (typeof document !== 'undefined') return document.cookie.includes('portal_channel=storefront');
    return false;
  });
}
